import back from '../../../assets/images/leave_game_button.png';
import bone from '../../../assets/images/bone.webp';

export default function Insufficientcoin(props) {
    const { toggleBonezContent } = props;
    const { toggleInviteContent } = props;
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft:"-75%" }}>
                <button className="button" style={{ marginLeft: "-2%", marginRight: "-25%" }} onClick={toggleBonezContent}>
                    <img src={back} alt="" width="30%" height="auto" style={{ transform: "rotate(180deg)" }} />
                </button>
                <span className="container-body-text" style={{ fontSize: "20px", color: "#87CEEB", marginTop: "1%", marginLeft: "0" }}>
                    Go Back
                </span>
            </div>

            <span className="container-body-text congratulations" style={{color: "#87CEEB", marginTop: "1%" }}>Not Enough Bonez</span>
            <span className="container-body-text bonezdeck" style={{ color: "#FFFFFF", marginTop: "1%" }}>You need at least 50</span>
            <span className="container-body-text bonezdeck" style={{color: "#FFFFFF", marginTop: "1%" }}>Bonez to get this.</span>

            <img className="shopicon5" alt="" src={bone} style={{marginTop: "8%" }} />

            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20%" }}>
                <button className="button invite" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} onClick={toggleInviteContent}>
                    <img src="/bonez/static/media/blue_button_400.758d8307f6e74bf496e7.webp" alt="" width="180%" height="auto" />
                    <span className="button-text" style={{ fontSize: "22px" }}>Invite Friends</span>
                </button>
            </div>

            <span className="container-body-text invite" style={{color: "#FFFFFF" }}>Friends can send you</span>
            <span className="container-body-text bonezdeck" style={{color: "#FFFFFF", marginTop: "0%" }}>bonez every day!</span>
        </>
    )
}
